import styled from "styled-components";
import { Box, Chip } from "@mui/material";
import { SPACING, ANIMATION } from "../../../utils/constants";

export const DateChip = styled(Chip)`
  background-color: var(--color-payment-date-chip-background) !important;
  font-weight: 600;
  color: var(--color-text-default);
  border-radius: 8px !important;

  .MuiChip-icon {
    color: var(--color-text-secondary);
  }
  .MuiChip-label {
    color: var(--color-text-default);
  }
`;

export const AmountRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${SPACING.sm}px 0;
  border-radius: 4px;
  transition: background-color ${ANIMATION.duration.normal}
    ${ANIMATION.easing.easeOut};

  &:hover {
    background-color: var(--hover-background);
  }
`;

export const IconWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${SPACING.sm}px;
  color: var(--color-text-secondary);
`;
